import { SvgIcon } from "@mui/material";
import React from "react";
import { ReactComponent as CollateLogoSvg } from "./collate_logo.svg";
import { ReactComponent as OpenMetadataLogoSvg } from "./openmetadata.svg";

export const CollateLogo = (props) => {
    return (
        <SvgIcon {...props}>
            <CollateLogoSvg />
        </SvgIcon>
    );
}

export const OpenMetadataLogo = (props) => (<SvgIcon {...props}><OpenMetadataLogoSvg /></SvgIcon>);